import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'
import { hexColors } from '@mobi/settings'

export const CampaignStyled = styled.div({
  background: hexColors.summerSky,
  color: hexColors.white,
  padding: `0.5rem ${spacing.sm}`,
})
export const CampaignTitleStyled = styled.p({
  fontSize: '1.2rem',
  margin: 0,
})

export const RemoveCampaignButtonStyled = styled.button({
  width: '2rem',
  height: '2rem',
  margin: 0,
  padding: 0,
  border: 0,
  backgroundColor: 'transparent',
  fontSize: 0,
  color: hexColors.white,
})
